import * as Guards from './deviation-report-display.enum.type.guard'

/** @see {isDeviationReportDisplayType} ts-auto-guard:type-guard */
export enum DeviationReportDisplayType {
  FULL_TOLERANCE_CONE = 'FULL_TOLERANCE_CONE',
  DETAILED_DEVIATION_CURVE = 'DETAILED_DEVIATION_CURVE',
}

export { Guards }
